


































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { formattedCompleteDate, formattedDate, formattedMonthDay, formattedMonthYear } from "@/filters/date/index";
import { getMonth, getDay, format } from "date-fns";
import { percentFilterDecimal } from "@/filters/percent";
import { formattedAreaInHa } from '@/filters/area'
import { AnalysisSummaryDTO, CropsStagesDTO } from "@/api/analyses/types";
import { CropStagesDTO } from '@/api/crops/types';
import InfoTooltip from '@/components/infoTooltip/InfoTooltip.vue';

@Component({
  name: "AgroTimeLine",
  filters: {
    formattedDate,
    formattedMonthDay,
    formattedMonthYear,
    formattedCompleteDate,
    formatteYear(value: string) {
      if (!value) {
        return "--";
      } else {
        const dateAux = new Date(value);
        dateAux.setUTCMinutes(dateAux.getUTCMinutes() + dateAux.getTimezoneOffset());
        const result = format(dateAux, "yyyy");
        return result;
      }
    },
    percentFilterDecimal,
    formattedAreaInHa,
  },
  components: {
    InfoTooltip,
  }
})
export default class AgroTimeLine extends Vue {

  private formattedDate = formattedDate;
  private formattedMonthDay = formattedMonthDay;
  private formattedMonthYear = formattedMonthYear;
  private formattedCompleteDate = formattedCompleteDate;
  private cutCaneDate = 0

  
  @Prop({ type: Array, required: true }) 
  private cropStages!: Array<CropStagesDTO | CropsStagesDTO>;

  @Prop(Object) 
  private analysisSummary!: AnalysisSummaryDTO;

  @Prop({ type: Boolean, default: false }) 
  private isSmall!: boolean;

  @Prop({ type: String, required: false, default:'SOY' })
  private cropType!: string;

  @Watch("cropStages", { immediate: true })
  private onCropsTagesChanged() {
      this.setYearByStageDate()
  }

  private getStageClass(stage: any) {
    return stage.date ? 'time-line--item item-small' : 'time-line--item time-line--item-not-filled item-small'
  }
  private getCircleClass(stage: any) {
    return stage.date ? 'time-line--item-circle time-line--item-circle-filled' : 'time-line--item-circle time-line--item-circle-not-filled'
  }

  private setYearByStageDate(){
     const plantedDate = this.cropStages.find((cropStage) => cropStage.stage === 'PLANTED' && cropStage.averageDate !== null)?.averageDate
     const haverstedDate = this.cropStages.find((cropStage) => cropStage.stage === 'HARVESTED' && cropStage.averageDate !== null)?.averageDate

    if(!!plantedDate && !!haverstedDate){
      const formattedPlantedYear = this.formattedYearCane(plantedDate)
      const formattedHarvestedYear = this.formattedYearCane(haverstedDate)
      this.cutCaneDate = (formattedHarvestedYear - formattedPlantedYear) - 1;
    } else {
      this.cutCaneDate = 0
    }
  }

  private formattedYearCane(date: any){
      return (new Date(date)).getFullYear()
  }


}
